import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import AttractionCreate from './AttractionCreate';
import AttractionEdit from './AttractionEdit';
import AttractionList from './AttractionList';

const AttractionPage = (props) => {
    let { path } = useRouteMatch();
    const refreshRef = React.useRef(null);
    const triggerRefresh = () => { if (refreshRef.current) refreshRef.current(); };

    return (
        <Switch>
            <Route path={`${path}/new`}>
                <AttractionList {...props} onRefreshRef={refreshRef} />
                <AttractionCreate {...props} onCreated={triggerRefresh} />
            </Route>
            <Route path={`${path}/:id`}>
                <AttractionList {...props} onRefreshRef={refreshRef} />
                <AttractionEdit {...props} onSaved={triggerRefresh} />
            </Route>
            <Route exact path={path}>
                <AttractionList {...props} />
            </Route>
        </Switch>
    );
};

export default AttractionPage;
